import { render, staticRenderFns } from "./RecipeFilterControlsModal.vue?vue&type=template&id=160cdaaa&scoped=true"
import script from "./RecipeFilterControlsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeFilterControlsModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RecipeFilterControlsModal.vue?vue&type=style&index=0&id=160cdaaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160cdaaa",
  null
  
)

export default component.exports